import Image from 'next/image';
import { useRouter } from 'next/router';

import { Button } from '@/ui/index';
import { ArrowRight } from '@/icons/index';

import styles from './DirectorItem.module.scss';

const DirectorItem = ({ item }) => {
  const router = useRouter();
  return (
    <div className={styles.directorItem}>
      <div className={styles.image}>
        <Image
          src={item?.image}
          alt={item?.name}
          title={item?.name}
          layout='fill'
          objectFit='cover'
          loading='lazy'
        />
      </div>
      <div className={styles.info}>
        <div className={styles.name}>{item?.name}</div>
        <div className={styles.position}>{item?.position}</div>
      </div>

      <Button
        onClick={() => router.push(`/directors/${item?.slug}`)}
        Component={'router'}
        size={'normal'}
        className={styles.button}
      >
        {item?.button_text} <ArrowRight width={24} />
      </Button>
    </div>
  );
};

export default DirectorItem;
